module.exports = __webpack_public_path__ + "static/media/beep_warning.154f2066.ogg";